import React, { useCallback, useEffect, useState } from "react";
import Button from "../../../components/Common/Button/Button";
import Input from "../../../components/Common/Input/Input";
import classes from "./SetUpDomainName.module.scss";
import { FormProvider, useForm } from "react-hook-form";
import { FormattedMessage, injectIntl } from "react-intl";
import AddIcon from "../../../components/Common/SvgIcons/AddIcon";
import {
  addDomainNameActionHandler,
  deleteDomainNameActionHandler,
  getDomainNamesActionHandler,
  isDomainNameExistsActionHandler,
} from "../../../store/actions/actionHandlers/adminActionHandler/organizationActionHandler";
import { useDispatch } from "react-redux";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import { setUpDomainName } from "../../../utils/mainTabs/admin/organizationSettings/setUpDomainName";
import { useFetchData } from "../../../hooks/useFetchData";
import DataTable from "../../../components/Common/DataTable/DataTable";
import Modal from "../../../components/Common/Modal/Modal";
import { yupResolver } from "@hookform/resolvers/yup";
import { AddDomainNameSchema } from "../../../utils/mainTabs/admin/organizationSettings/setUpDomainSchema";
import EditDomainNameModal from "./EditDomainName/EditDomainNameModal";

const SetUpDomainName = ({ intl }) => {
  const pageSize = 8;
  const dispatch = useDispatch();
  const methods = useForm({
    defaultValues: { AddDomainName: "" },
    resolver: yupResolver(AddDomainNameSchema),
    mode: "onChange",
  });
  const {
    handleSubmit,
    reset,
    formState: { isValid, errors, setValue },
  } = methods;

  const [isAddDomainNameExists, setIsAddDomainNameExists] = useState(null);
  const [addDomainNameExistsLoader, setAddDomainNameExistsLoader] =
    useState(false);
  const [tableColumns, setTableColumns] = useState([]);
  const [deleteDomainNameId, setDeleteDomainNameId] = useState(0);
  const [deleteDomainName, setDeleteDomainName] = useState("");
  const [editDomainNameId, setEditDomainNameId] = useState(0);
  const [editDomainName, setEditDomainName] = useState("");

  const [deleteDomainNameLoader, setDeleteDomainNameLoader] = useState(false);
  const { searchPlaceHolder, columns } = setUpDomainName;
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    loading,
    totalRows,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getDomainNamesActionHandler, pageSize);

  const handleEditModal = useCallback((domainNameId, domainName) => {
    setEditDomainNameId(domainNameId);
    setEditDomainName(domainName);
  }, []);
  const handleDeleteModal = useCallback((domainId, domainName) => {
    setDeleteDomainNameId(domainId);
    setDeleteDomainName(domainName);
  }, []);

  const handleAddDomainNameExists = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      let patter =
        "/^[a-zA-Z0-9][a-zA-Z0-9-_]{0,61}[a-zA-Z0-9]{0,1}.([a-zA-Z]{1,6}|[a-zA-Z0-9-]{1,30}.[a-zA-Z]{2,3})$/";
      if (val) {
        dispatch(isDomainNameExistsActionHandler(val)).then((response) => {
          if (response && response.status === 200) {
            // setAddTrainingNameExistsLoader(false);
            if (response.data) {
              setIsAddDomainNameExists(true);
            } else {
              setIsAddDomainNameExists(false);
            }
          }
        });
      } else {
        setIsAddDomainNameExists(false);
      }
    },
    [dispatch, setIsAddDomainNameExists]
  );
  const handleDeleteDomainName = () => {
    setDeleteDomainNameLoader(true);
    dispatch(deleteDomainNameActionHandler(deleteDomainNameId)).then(
      (response) => {
        if (response) {
          const filterData = data.filter(
            (row) => row.id !== deleteDomainNameId
          );
          const filterUpdatedData = data.filter(
            (row) => row.id !== deleteDomainNameId
          );
          setData(filterData);
          setUpdatedData(filterUpdatedData);
          setDeleteDomainNameLoader(false);
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `Training Type ${deleteDomainName} deleted successfully`
            )
          );
        }
        handleDeleteModal(0, "");
        handleSearchQuery();
      }
    );
  };
  useEffect(() => {
    let newTabelColumns = columns(handleDeleteModal, handleEditModal);
    setTableColumns(newTabelColumns);
  }, [columns, handleDeleteModal, handleEditModal]);

  const onSubmit = (data) => {
    dispatch(addDomainNameActionHandler(data.AddDomainName, 0)).then(
      (response) => {
        if (response) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `Domain name ${data.AddDomainName} created successfully`
            )
          );
          handleSearchQuery();
          reset();
        }
      }
    );
  };
  return (
    <div className={classes.setUpDomainName}>
      <FormProvider {...methods}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={classes.setUpDomainName__form}
        >
          <div className={classes.setUpDomainName__form__addField}>
            <Input
              name={"AddDomainName"}
              placeholder={intl.formatMessage({
                id: `DOMAIN_NAME`,
              })}
              height="5"
              width="53"
              gap="0"
              onChange={(e) => handleAddDomainNameExists(e)}
              // loading={addDomainNameExistsLoader}
              // error={addTrainingTypeErrors?.["AddTrainingType"]?.message}
            />
            {errors?.AddDomainName?.message ? (
              <div className={classes.setUpDomainName__form__addField__error}>
                {errors?.AddDomainName?.message}
              </div>
            ) : (
              isAddDomainNameExists && (
                <div className={classes.setUpDomainName__form__addField__error}>
                  Domain name already exists
                </div>
              )
            )}
          </div>
          <Button
            label={"Add Domain Name"}
            disabled={!isValid || isAddDomainNameExists}
            icon={AddIcon}
            type="submit"
            height="5"
            width="18"
            light
            //loading={addTrainingTypeLoader && !editTrainingTypeId}
          />
        </form>
      </FormProvider>
      <DataTable
        columns={tableColumns}
        defaultData={data}
        setDefaultData={setData}
        data={updatedData}
        setData={setUpdatedData}
        totalRows={totalRows}
        loading={loading}
        uniqueFieldName={"id"}
        fetchMoreData={handleCurrentPage}
        filterable
        setSearchQuery={handleSearchQuery}
        placeholder={searchPlaceHolder}
      />
      <Modal
        handleSubmit={handleDeleteDomainName}
        isOpen={deleteDomainNameId}
        heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
        toggle={() => handleDeleteModal(0, "")}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
        width={"46.2"}
        height={"26.9"}
        loading={deleteDomainNameLoader}
      >
        <div className={classes.setUpDomainName__deleteModal}>
          <div className={classes.setUpDomainName__deleteModal__text}>
            <FormattedMessage id="TRAINING_DEL_CONFIRM" />
          </div>
        </div>
      </Modal>
      <EditDomainNameModal
        editDomainNameId={editDomainNameId}
        editDomainName={editDomainName}
        handleSearchQuery={handleSearchQuery}
        handleEditModal={handleEditModal}
      />
    </div>
  );
};

export default injectIntl(SetUpDomainName);
